export const CLAIMS = {
    /** Indicate access to Supervisor's PTO Calendar View */
    SupervisorPTOCalendarView: "http://action.ain1.com/claims/supervisor/pto-calendar-view-access",
    DisableMealBreakRounding: "http://action.ain1.com/claims/disable-meal-break-rounding"
};

export const CLAIM_ACTIONS = {
    Demand: "demand",
    Deny: "deny",
    Grant: "grant"
};

export const CLAIMS_ENTITY = {
    Security_EntityType_Global : "Global",
    Security_EntityType_ParentCompany : "ParentCompany",
    Security_EntityType_Company : "Company",
    Security_EntityType_Menu : "Menu",
    Security_EntityType_ERPSysId : "ERPSysId",
    Security_EntityType_OffSysId : "OffSysId",
    Security_EntityType_ERPEmployeeTimecardType : "ERPEmployeeTimecardType",
    Security_EntityType_ERPEmployeeStatus : "ERPEmployeeStatus",
    Security_EntityType_Features : "Feature",
    Security_EntityType_Timecard : "Timecard",
    Security_EntityType_Placement : "Placement"    
};

export const FEATURES = {
    PTO_Calendar_View : "PTOCalendarView",    
};